<template>
	<div>
		<div class="row form-group">
			<div class="col-md-12 container-fluid">
				<table ref="grid"
					   class="mdl-data-table table table-responsive dataTable no-footer dtr-inline"
					   role="grid"
					   width="100%">
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	import {PayeeFormClass} from "./PayeeFormClass.js";
	import dataTables from 'datatables';
	import {common} from "../../../global/common.js";

	export default {
		name: "PayeeSelection",
		props: {payeeFormInstance: {type: [PayeeFormClass], required: true}},
		data() {
			return {
				grid: null,
			}
		},
		async mounted() {
			let payees = await this.payeeFormInstance.getAvailablePayees();
			this.initGrid(payees);
		},
		methods: {
			initGrid(data) {
				this.grid = $(this.$refs.grid).DataTable({
					columns: [
						{
							title: 'Payee', data: 'payeeName'
						},
						{
							title: 'Bank', data: 'bankingInfo.bankName'
						},
						{
							title: 'Account Number', data: 'bankingInfo.accountNumber'
						},
						{
							title: 'Actions', data: null, render() {
								return '<button class="payee-selection btn btn-green btn-xs">SELECT</button>';
							}
						}

					],
					data: data,
					displayLength: 5,
					responsive: true
				});
				this.addGridListeners();
			},
			addGridListeners() {
				let self = this;
				//console.log("Adding listener to payee selection grid:", $(this.$refs.grid));
				$(this.$refs.grid).off('click', '.payee-selection').on('click', '.payee-selection', function (event) {
					let data = common.getRowData(this, self.grid);
					//console.log("Emiting event from payee selection", data);
					self.$emit('onPayeeSelection', data);
					event.preventDefault();
				})
			}
		}
	}
</script>

<style scoped>

</style>